import { axios } from '@/utils/request'

// 赞美诗
export function getPoems(params) {
    return axios.get('poems', { params })
}

export function getPoemDetail(poemId) {
    return axios.get(`poems/${poemId}`)
}

// 圣经
export function getBibles(parameter) {
    return axios({
        url: 'bibles/volumes',
        method: 'get',
        params: parameter
    })
}

export function getChapters(volumeSn) {
    return axios({
        url: `bibles/${volumeSn}/chapters`,
        method: 'get'
    })
}

export function getVerses(volumeSn, chapterSn) {
    return axios({
        url: `bibles/${volumeSn}/chapters/${chapterSn}/verses`,
        method: 'get'
    })
}

export function getUnionBibles(parameter) {
    return axios({
        url: 'union_bibles',
        method: 'get',
        params: parameter
    })
}

export function getUnionBibleVerses(volumeSn, chapterSn) {
    return axios({
        url: `union_bibles/${volumeSn}/chapters/${chapterSn}/content`,
        method: 'get'
    })
}

export function bibleSearch(data) {
    return axios.post('bibles/search', data)
}
